import React from "react";
import { Checkbox, KpiBenchmarkLegend } from "@sia/style-guide";
import { KPI_SCORECARD_TRANSLATION_KEYS } from "pages/Evaluations/KeyFigures/kpiConfiguration";
import "./Legend.scss";

function Legend({ canDisplayOwnData, showCustomerData, setShowCustomerData, translate }) {
  return (
    <div className={"sia-shared-legend"}>
      <div className="sia-padding-02-right">
        <Checkbox
          id={"show-my-data"}
          value={showCustomerData}
          onChange={(_, v) => {
            setShowCustomerData(v);
          }}
          label={translate("benchmarking.evaluations.overheads.accounts.show-my-data")}
          disabled={!canDisplayOwnData}
        />
      </div>
      <KpiBenchmarkLegend
        label={translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.label)}
        title={translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.title)}
        description={translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.description)}
        normalDistributionLabel={translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.normalDistribution)}
        meanLabel={translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.mean)}
        sdLabel={translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.sd)}
        higherLabel={translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.higher)}
        lowerLabel={translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.lower)}
        closeLabel={translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.close)}
        labels={{
          belowFair: translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.belowFair),
          fair: translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.fair),
          good: translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.good),
          veryGood: translate(KPI_SCORECARD_TRANSLATION_KEYS.legend.veryGood),
        }}
      />
    </div>
  );
}

export default Legend;
